import { render } from "./Accessories.vue?vue&type=template&id=f7c03024"
import script from "./Accessories.vue?vue&type=script&lang=js"
export * from "./Accessories.vue?vue&type=script&lang=js"

import "./Accessories.vue?vue&type=style&index=0&id=f7c03024&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__